export const Series = (seriesData) => ({
    ...seriesData,
    isRankingsSeries() {
        return (
            !!seriesData.rankingsDivisions?.length > 0 ||
            !!seriesData.divisionsSeasons?.some(
                (divisionSeason) => divisionSeason.rankings,
            )
        );
    },
    isMembershipSeries() {
        return (
            !!seriesData.membershipDivisions?.length > 0 ||
            !!seriesData.divisionsSeasons?.some(
                (divisionSeason) => divisionSeason.membership,
            )
        );
    },
});
